import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/lib/supabase";
import { useNavigate } from "react-router-dom";

export const LogoutButton = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      toast({
        title: "Logout realizado com sucesso",
        description: "Você será redirecionado para a página de login.",
      });
      navigate("/login");
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Erro ao fazer logout",
        description: "Tente novamente em alguns instantes.",
      });
    }
  };

  return (
    <Button
      variant="ghost"
      className="w-full flex items-center justify-start space-x-3 px-4 py-3 text-red-600 hover:bg-red-50 hover:text-red-700"
      onClick={handleLogout}
    >
      <LogOut size={20} />
      <span className="font-medium">Sair</span>
    </Button>
  );
};